<template>
    <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-start mt-12 sm:justify-center" style="z-index:999999;">
        <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
            <div class="absolute inset-0 bg-black opacity-75"></div>
        </div>
        <div class="bg-white overflow-auto shadow-xl transform transition-all max-w-6xl max-h-128 md:max-h-192" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
                <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="$emit('close')">
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="sm:flex sm:items-start border-b border-gray-400">
                    <div class="mt-3 text-center sm:mt-0 sm:text-left">
                        <h3 class="text-lg leading-6 font-medium text-black pb-2" id="modal-headline">
                            Record {{ change.event }}
                        </h3>
                    </div>
                </div>
                <div class="mt-6">
                    <div v-if="change.event === 'updated'" class="lg:flex justify-between">
                        <div class="flex-grow overflow-x-auto">
                            <h2 class="mb-2">Old</h2>
                            <pre>{{ old }}</pre>
                        </div>
                        <div class="flex-shrink-0 border-t lg:border-t-0 border-l border-gray-400 my-3 lg:my-0 lg:mx-3"></div>
                        <div class="flex-grow overflow-x-auto">
                            <h2 class="mb-2">New</h2>
                            <pre>{{ attributes }}</pre>
                        </div>
                    </div>
                    <div v-else>
                        <pre>{{ change.event === 'created' ? attributes : old }}</pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActivityLogModal",
    props: {
      change: {
          required: true,
          type: Object,
      }
    },
    data() {
        return {
            old: {},
            attributes: {},
        }
    },
    computed: {
        title: () => {
            if (this.change.event === 'created') {
                return 'Record '
            }
        }
    },
    mounted() {
        document.body.classList.add('overflow-hidden')
        const properties = JSON.parse(this.change.properties);
        this.old = properties.old;
        this.attributes = properties.attributes;
    },
    beforeDestroy() {
        document.body.classList.remove('overflow-hidden')
    },
}
</script>
